import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

export default class ItemBoundRect {
  transformMatrixL: string;

  transformMatrixR: string;

  transformMatrixT: string;

  transformMatrixB: string;

  lineL: SVGElement;

  lineR: SVGElement;

  lineT: SVGElement;

  lineB: SVGElement;

  public spt: SVGSprite;

  viewObj: Element;

  x: number;

  y: number;

  transformMatrix: string;

  _width: number;

  get width() { return this._width; }

  set width(val) {
    this._width = Math.round(val);
  }

  _height: number;

  get height(): number { return this._height; }

  set height(val: number) {
    this._height = Math.round(val);
  }

  /**
   * コンストラクタ
   */
  constructor(container: Element, id: string) {
    this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    this.viewObj.id = id;

    // 各ラインの作成 ※Rectで作成すると、アイテムが選択できなくなるので、ラインで代用
    this.lineL = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.lineL.setAttribute('stroke', '#3598DC');
    this.lineL.setAttribute('stroke-width', '1');
    this.lineL.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
    this.lineL.setAttribute('id', 'lineL');
    this.viewObj.appendChild(this.lineL);

    this.lineR = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.lineR.setAttribute('stroke', '#3598DC');
    this.lineR.setAttribute('stroke-width', '1');
    this.lineR.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
    this.lineR.setAttribute('id', 'lineR');
    this.viewObj.appendChild(this.lineR);

    this.lineT = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.lineT.setAttribute('stroke', '#3598DC');
    this.lineT.setAttribute('stroke-width', '1');
    this.lineT.setAttribute('stroke-linecap', 'square');
    this.lineT.setAttribute('stroke-linejoin', 'miter');

    this.lineT.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
    this.lineT.setAttribute('id', 'lineT');
    this.viewObj.appendChild(this.lineT);

    this.lineB = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.lineB.setAttribute('stroke', '#3598DC');
    this.lineB.setAttribute('stroke-width', '1');
    this.lineB.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, 100)));
    this.lineB.setAttribute('id', 'lineB');
    this.viewObj.appendChild(this.lineB);

    this.spt = new SVGSprite(this.viewObj);
    container.appendChild(this.viewObj);
    this.hide();
  }

  /**
   * リサイズ
   */
  resize(rect: { width: number, height: number, x?: number, y?: number }, itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    // 保持
    this.width = rect.width;
    this.height = rect.height;
    const { x, y } = rect;
    const cp = (itemInfo.id.substring(0, 3) === 'col' || itemInfo.id.substring(0, 3) === 'bem') ? new marietta.core.Point(x + this.width / 2, y + this.height / 2) : new marietta.core.Point(itemInfo.x, itemInfo.y);
    this.lineL.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, rect.height)));
    this.transformMatrixL = `matrix(1,0,0,1,${cp.x - rect.width / 2},${cp.y - rect.height / 2})`;
    this.lineL.setAttribute('transform', this.transformMatrixL);

    this.lineR.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(0, rect.height)));
    this.transformMatrixR = `matrix(1,0,0,1,${cp.x + rect.width / 2},${cp.y - rect.height / 2})`;
    this.lineR.setAttribute('transform', this.transformMatrixR);

    this.lineT.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(rect.width, 0)));
    this.transformMatrixT = `matrix(1,0,0,1,${cp.x - rect.width / 2},${cp.y - rect.height / 2})`;
    this.lineT.setAttribute('transform', this.transformMatrixT);

    this.lineB.setAttribute('d', marietta.webcad.util.SVGUtil.getPathLineString(new marietta.core.Point(0, 0), new marietta.core.Point(rect.width, 0)));
    this.transformMatrixB = `matrix(1,0,0,1,${cp.x - rect.width / 2},${cp.y + rect.height / 2})`;
    this.lineB.setAttribute('transform', this.transformMatrixB);
  }

  /**
   * 移動 XY
   */
  move(x: number, y: number) {
    this.x = x;
    this.y = y;
    this.updateTranslate();
  }

  /**
  * 移動X
  */
  moveX(x: number) {
    this.x = x;
    this.updateTranslate();
  }

  /**
  * 移動Y
  */
  moveY(y: number) {
    this.y = y;
    this.updateTranslate();
  }

  /**
   * 表示ON
   */
  show() {
    this.spt.element.style.visibility = 'visible';
  }

  /**
   * 表示OFF
   */
  hide() {
    this.spt.element.style.visibility = 'hidden';
  }

  /**
   * Translateのアップデート
   */
  updateTranslate() {
    this.transformMatrix = `matrix(1,0,0,1,${this.x},${this.y})`;
    this.viewObj.setAttribute('transform', this.transformMatrix);
  }
}
